
import { BasicModel } from "@goodgamestudios/core";
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2StandardOkDialog } from "../../../view/dialogs/Poker2StandardOkDialog";
import { Poker2Command } from "../Poker2Command";

export class EMVCommand extends Poker2Command {
    protected get cmdId(): string {
        return "emv";
    }

    public executeCommand(error: number, params: any[]): boolean {
        switch (error) {
            case 0:
                var paramObj: any = JSON.parse(params[1]);
                Poker2Model.userData.email = paramObj.email;
                Poker2Model.userData.emailVerified = true;
                this.controller.dispatchEvent(new Poker2UserEvent("emailverificationCompleted"));
                return true;
                break;
            case 102:
                Poker2Model.userData.emailVerified = true;
                this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_bug"),
                    Poker2Model.languageData.getTextById("errorcode_" + error)));
                break;
            case 101:
                this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_bug"),
                    Poker2Model.languageData.getTextById("errorcode_" + error), this.bindFunction(this.onAllowMail)));
                break;
            case 103:
                this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_bug"),
                    Poker2Model.languageData.getTextById("generic_invalid_email_provider")));
                break;
            case 100:
                this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_register_errormistake"),
                    Poker2Model.languageData.getTextById("generic_register_emaillong_copy")));
                break;
            case 24:
                this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_register_errormistake"),
                    Poker2Model.languageData.getTextById("generic_register_email_copy")));
                break;
            case 23:
                this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_register_errormistake"),
                    Poker2Model.languageData.getTextById("generic_register_error_accountalreadyexists")));
                break;
            default:
                this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_bug"),
                    Poker2Model.languageData.getTextById("errorcode_" + error)));
                break;
        }
        this.controller.dispatchEvent(new Poker2UserEvent("emailverificationFaild", [error]));
        return (error == 0);
    }

    private onAllowMail(params: any[]): void {
        var paramObj: any = { sendMail: 1 };
        BasicModel.smartfoxClient.sendMessage("emb", [JSON.stringify(paramObj)]);
        Poker2Model.userData.allowMail = true;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
